var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu-item',{key:_vm.MenuItem.path,attrs:{"index":_vm.MenuItem.path}},[_c('a',{attrs:{"href":'#' + _vm.MenuItem.path}},[_c('div',{staticClass:"el-menu-item-wrapper"},[_c('i',{class:['iconfont', _vm.MenuItem.meta.icon]}),_c('span',{attrs:{"slot":"title"},domProps:{"textContent":_vm._s(_vm.MenuItem.meta.title)},slot:"title"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }